import {AsyncAction} from 'overmind'
import {
  MultipleSiteSuspendedPeriodPayload,
  MultipleSiteSuspendedPeriodResponse,
  PublicHolidayListRequest,
  PublicHolidayPayload,
  PublicHolidaySuspendedPeriodPayload,
  PublicHolidaySuspendedPeriodResponse
} from './state'

export const newMultipleSiteSuspendedPeriod: AsyncAction<
  MultipleSiteSuspendedPeriodPayload,
  MultipleSiteSuspendedPeriodResponse | undefined
> = async ({state, effects}, params: MultipleSiteSuspendedPeriodPayload) => {
  try {
    const res = await effects.v1.settings.multipleSiteSuspendedPeriod.multipleSiteSuspendedPeriodsApi.newMultipleSiteSuspendedPeriod(
      params
    )
    return res
  } catch (err) {
    state.v1.settings.multipleSiteSuspendedPeriod.error = err as Error
  }
}

export const newPublicHolidaySuspendedPeriod: AsyncAction<
  PublicHolidaySuspendedPeriodPayload,
  PublicHolidaySuspendedPeriodResponse | undefined
> = async ({state, effects}, params: PublicHolidaySuspendedPeriodPayload) => {
  try {
    const res = await effects.v1.settings.multipleSiteSuspendedPeriod.multipleSiteSuspendedPeriodsApi.newPublicHolidaySuspendedPeriod(
      params
    )
    return res
  } catch (err) {
    state.v1.settings.multipleSiteSuspendedPeriod.error = err as Error
  }
}

export const getPublicHolidays: AsyncAction<PublicHolidayListRequest, PublicHolidayPayload[] | undefined> = async (
  {state, effects},
  params: PublicHolidayListRequest
) => {
  try {
    const res = await effects.v1.settings.multipleSiteSuspendedPeriod.multipleSiteSuspendedPeriodsApi.getPublicHolidays(
      params
    )
    return res
  } catch (err) {
    state.v1.settings.multipleSiteSuspendedPeriod.error = err as Error
  }
}
